import { BooleanInput } from '@angular/cdk/coercion';
import { booleanAttribute, Directive, HOST_TAG_NAME, inject, input } from '@angular/core';
import { UiCanDisable } from '../internal/disabled';
import { setupInteractions } from '../internal/interactions/interactions';
import { provideUiButtonState, uiButtonState } from './button.state';

@Directive({
    selector: '[uiButton]',
    exportAs: 'uiButton',
    providers: [provideUiButtonState()],
    host: {
        '[attr.data-disabled]': 'state.disabled() ? "" : null',
        '[attr.disabled]': 'isButton && state.disabled() ? true : null'
    }
})
export class UiButtonDirective implements UiCanDisable {
    /**
     * Whether the button is disabled
     */
    readonly disabled = input<boolean, BooleanInput>(false, {
        transform: booleanAttribute
    });

    /**
     * Get the tag name of the element.
     */
    private readonly tagName = inject(HOST_TAG_NAME);

    /**
     * Detect if this is an HTML button element.
     */
    protected readonly isButton = this.tagName.toLowerCase() === 'button';

    /**
     * The button state
     */
    protected readonly state = uiButtonState<UiButtonDirective>(this);

    constructor() {
        // setup the hover, press, and focus-visible listeners
        setupInteractions({
            disabled: this.state.disabled,
            hover: true,
            press: true,
            focusVisible: true
        });
    }
}
